import { Left, Right } from "@insightfulscience/shared-utils/either";
import { mapGqlError } from "@insightfulscience/shared-utils/gqlClient/GqlError";
import routes, { toCompleteProfilePage, navToPath } from "../routes";

const expectedErrors = mapGqlError({
	401: "errors.TOKEN_EXPIRED",
	404: "errors.TOKEN_NOT_FOUND",
});

const navToPathWithSettledTokens = ({ token, refreshToken, trialId }, storageService) => {
	storageService.trial.write({ isNew: true });
	storageService.token.write(token);
	storageService.refreshToken.write(refreshToken);
	toCompleteProfilePage(trialId);
};

const navToCompleteProfilePage = (requestTrial, storageService) =>
	requestTrial.token && requestTrial.refreshToken
		? navToPathWithSettledTokens(requestTrial, storageService)
		: toCompleteProfilePage(requestTrial.trialId);

const handleSuccess = (requestTrial, storageService) =>
	!requestTrial.isAuthorized
		? navToPath(routes.confirmEmail)
		: navToCompleteProfilePage(requestTrial, storageService);

export const requestFreeTrial = ({ email }, turingToken, turingType) => ({
	trialService,
	storageService,
}) => {
	storageService.trial.clear();
	return trialService
		.requestFreeTrial(email, turingToken, turingType)
		.then(({ requestTrial }) => handleSuccess(requestTrial, storageService))
		.then(Right)
		.catch(Left.from(expectedErrors));
};

export default requestFreeTrial;
